const doc = [({"en":({"js":({"admin":({"competitions":({"index":({"new_competition":"New competition", "the_competition_was_deleted":"The competition was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;